import { memo } from "react";

import { IconTriangleArrowDown } from "@synthesis/shared-icons";
import { Button, Dropdown } from "@synthesis/shared-ui";

import {
  createDeleteNotificationsDropdownState,
  DELETE_NOTIFICATIONS_DROPDOWN_SCHEME,
  type NotificationDeleteType,
} from "../notifications-panel.lib";
import { useApplicationNotifications } from "../use-application-notifications";

export const DeleteNotificationsDropdown = memo(() => {
  const { deleteNotificationsByType } = useApplicationNotifications();

  const deleteByType = (type: NotificationDeleteType) => {
    deleteNotificationsByType(type);
  };

  return (
    <Dropdown
      align="end"
      portal={false}
      scheme={DELETE_NOTIFICATIONS_DROPDOWN_SCHEME}
      size="sm"
      state={createDeleteNotificationsDropdownState(deleteByType)}
      trigger={
        <Button type="button" size="sm" theme="text" className="shrink-0" leftIcon={<IconTriangleArrowDown className="size-5" />}>
          Удалить
        </Button>
      }
    />
  );
});

DeleteNotificationsDropdown.displayName = "DeleteNotificationsDropdown";
